import React from 'react';
import { NewModal } from '../../NewModal';
import { useOrganizationVideosQuery } from 'lib/api/organizationVideo/useOrganizationVideoQuery';
import { Flex } from 'lib/components/styles/layout';
import { LoadingIndicator } from 'lib/components/LoadingIndicator';
import { ModalOrganizationDuplicatePlaylistForm } from './ModalOrganizationDuplicatePlaylistForm';

interface IModalOrganizationDuplicatePlaylistProps {
  filter: {
    [key: string]: string[];
  };
  handleModalClose: () => void;
}

export const ModalOrganizationDuplicatePlaylist = ({
  filter,
  handleModalClose,
}: IModalOrganizationDuplicatePlaylistProps) => {
  const playlist = filter.playlist?.[0] || '';

  // queries
  const { data, isLoading: isLoadingVideos } = useOrganizationVideosQuery(
    {
      limit: 500,
      page: 0,
      filter: { playlist: [playlist] },
    },
    true,
    handleModalClose
  );
  const videos = data?.videos || [];

  const isPreparingData = isLoadingVideos || !videos;

  return (
    <NewModal
      closeModal={handleModalClose}
      headerText='Duplicate Playlist'
      style={{
        content: { width: '827px' },
      }}
    >
      {isPreparingData ? (
        <Flex
          width='100%'
          height='400px'
          justifyContent='center'
          alignItems='center'
        >
          <LoadingIndicator isLoading={isPreparingData} />
        </Flex>
      ) : (
        <ModalOrganizationDuplicatePlaylistForm
          videos={videos}
          handleModalClose={handleModalClose}
        />
      )}
    </NewModal>
  );
};
